import Bezier from "bezier-js";
import { cancel } from "common/promises";
import { MAXIMUM_HEIGHT, MAXIMUM_WIDTH } from "common/screen";
import { Sheets } from "common/sheets";
import { easePolyInOut } from "d3-ease";
const left = {
    x: 283 - MAXIMUM_WIDTH / 2,
    y: 948 - MAXIMUM_HEIGHT / 2,
};
const right = {
    x: 444 - MAXIMUM_WIDTH / 2,
    y: 948 - MAXIMUM_HEIGHT / 2,
};
const curveHeight = -70;
const leftToRightCurve = new Bezier(left.x, left.y, left.x, left.y + curveHeight, right.x, right.y + curveHeight, right.x, right.y);
const rightToLeftCurve = new Bezier(right.x, right.y, right.x, right.y + curveHeight, left.x, left.y + curveHeight, left.x, left.y);
const ease = easePolyInOut.exponent(0.7);
const betweenZeroOne = (x) => {
    if (x > 1) {
        return 1;
    }
    if (x < 0) {
        return 0;
    }
    return x;
};
const animationDuration = [300, 280, 270, 250];
const animationIdleDuration = [350, 330, 310, 290];
class WaitingButtonListen {
    constructor(cButton) {
        this.cButton = cButton;
    }
    waitOn(button) {
        if (button === "A") {
            this.cButton.goalState = "left";
        }
        else {
            this.cButton.goalState = "right";
        }
        this.cButton.lastButtonClicked = Date.now();
    }
}
class CButtonIdleEventListeners {
    constructor() {
        this.listeners = [];
    }
    add(listener) {
        this.listeners.push(listener);
    }
    stop() {
        for (const listener of this.listeners) {
            listener.stop();
        }
    }
    left() {
        for (const listener of this.listeners) {
            listener.left();
        }
    }
    right() {
        for (const listener of this.listeners) {
            listener.right();
        }
    }
    dispose() {
        this.listeners = [];
    }
}
export class CButton {
    constructor(pixiContext, sheets) {
        this.animation = null;
        this.currentState = "left";
        this.goalState = "left";
        this.onButtonListener = new WaitingButtonListen(this);
        this.loop = false;
        this.lastButtonClicked = Date.now();
        this.speed = 1;
        this.idleEventListeners = new CButtonIdleEventListeners();
        this.pixiContext = pixiContext;
        this.sprite = Sheets.sprite(sheets, imageName);
        this.sprite.visible = false;
        this.sprite.position.set(left.x, left.y);
    }
    play() {
        this.sprite.visible = true;
        if (this.animation != null) {
            return;
        }
        this.animation = cancel.root(async (canceler) => {
            canceler.check();
            while (true) {
                if (Date.now() - this.lastButtonClicked < 300) {
                    this.loop = true;
                }
                else {
                    this.loop = false;
                }
                if (this.loop) {
                    if (this.currentState === "left") {
                        await this.moveRight();
                    }
                    else {
                        await this.moveLeft();
                    }
                }
                else {
                    if (this.currentState === "left" && this.goalState === "left") {
                        await this.leftIdle();
                    }
                    if (this.currentState === "left" && this.goalState === "right") {
                        await this.moveRight();
                    }
                    if (this.currentState === "right" && this.goalState === "right") {
                        await this.rightIdle();
                    }
                    if (this.currentState === "right" && this.goalState === "left") {
                        await this.moveLeft();
                    }
                }
            }
        });
    }
    async leftIdle() {
        this.idleEventListeners.left();
        const curve = new Bezier(left.x, left.y, left.x, left.y + curveHeight, left.x, left.y + curveHeight, left.x, left.y);
        await this.pixiContext.animate({
            start: 0,
            destination: 1,
            durationMS: animationIdleDuration[this.speed - 1],
            setter: (value) => {
                value = betweenZeroOne(ease(value));
                const { x, y } = curve.get(value);
                this.sprite.position.set(x, y);
            },
        });
    }
    async rightIdle() {
        this.idleEventListeners.right();
        const curve = new Bezier(right.x, right.y, right.x, right.y + curveHeight, right.x, right.y + curveHeight, right.x, right.y);
        await this.pixiContext.animate({
            start: 0,
            destination: 1,
            durationMS: animationIdleDuration[this.speed - 1],
            setter: (value) => {
                value = betweenZeroOne(ease(value));
                const { x, y } = curve.get(value);
                this.sprite.position.set(x, y);
            },
        });
    }
    dispose() {
        this.idleEventListeners.dispose();
        if (this.animation != null) {
            this.animation.canceler.cancel();
            this.animation = null;
        }
    }
    async moveRight() {
        this.idleEventListeners.stop();
        await this.pixiContext.animate({
            start: 0,
            destination: 1,
            durationMS: animationDuration[this.speed - 1],
            setter: (value) => {
                value = betweenZeroOne(ease(value));
                const { x, y } = leftToRightCurve.get(value);
                this.sprite.position.set(x, y);
            },
        });
        this.currentState = "right";
    }
    async moveLeft() {
        this.idleEventListeners.stop();
        await this.pixiContext.animate({
            start: 0,
            destination: 1,
            durationMS: animationDuration[this.speed - 1],
            setter: (value) => {
                value = betweenZeroOne(ease(value));
                const { x, y } = rightToLeftCurve.get(value);
                this.sprite.position.set(x, y);
            },
        });
        this.currentState = "left";
    }
}
export const imageName = "버튼C.png";
//# sourceMappingURL=cButton.js.map